<template>
  <div class="newsletter-sign-up critical-component-clear grid">
    <div class="newsletter-sign-up__content col xs-span l5-8">
      <div class="newsletter-sign-up__logo">
        <brand-logo />
      </div>

      <h2
        v-if="settings.title"
        class="text-heading-l"
        v-text="settings.title"
      />

      <h2
        v-if="settings.body"
        class="text-body-xs-regular"
        v-text="settings.body"
      />
    </div>

    <form
      id="ometria_form"
      class="newsletter-sign-up__form col xs-span l4-9"
      action="https://api.ometria.com/forms/signup"
      method="post"
    >
      <div class="form-group">
        <div class="form-group__field newsletter-sign-up__fields">
          <input
            type="hidden"
            name="__form_id"
            :value="credentials?.formId"
          >
          <input
            type="hidden"
            name="email"
            value=""
            autocomplete="off"
          >
          <div class="visually-hidden">
            <label
              class="form-group__label"
              for="hidden-email"
            >
              <span v-text="$string('general.ometria.email')" />
            </label>
            <input
              id="hidden-email"
              name="__email"
              type="email"
              value=""
              autocomplete="off"
            >
          </div>

          <input
            name="@account"
            type="hidden"
            :value="credentials?.accountId"
          >
          <input
            name="@subscription_status"
            type="hidden"
            value="SUBSCRIBED"
          >
          <label
            class="form-group__label visually-hidden"
            for="email"
          >
            <span v-text="$string('general.ometria.email')" />
          </label>
          <input
            id="email"
            v-model="email"
            name="ue"
            required
            :placeholder="$string('general.ometria.email')"
            type="email"
            @input="success = false; error = false"
          >

          <btn
            attributes="name='submit'"
            class="newsletter-sign-up__submit"
            :label="buttonText"
            type="submit"
          />
        </div>
      </div>

      <p
        v-if="error"
        class="text-body-s-regular newsletter-sign-up__error"
        v-text="error"
      />

      <p
        v-if="success"
        class="text-body-s-regular newsletter-sign-up__success"
        v-text="$string('general.ometria.success')"
      />
    </form>
  </div>
</template>

<script>

/**
 * Vue: Newsletter sign up (newsletter-sign-up)
 * -----------------------------------------------------------------------------
 * A Section that contains the newsletter sign up form.
 * - Component settings: section / dynamic / async / scroll
 *
 * @param {String} settings.title - Section's title.
 * @param {String} settings.body - Section's body text.
 *
 */
import Btn from '~global/btn/btn'
import BrandLogo from '~icons/general/brand-logo.svg'

export default {
  name: 'NewsletterSignUp',

  components: { Btn, BrandLogo },

  props: {
    settings: {
      type: Object,
      default: () => ({
        title: '',
        body: '',
      }),
    },
  },

  data() {
    return {
      credentials: cnvs.credentials.ometria,
      success: false,
      error: false,
      email: '',
    }
  },

  computed: {

    /**
     * Compute button text.
     * @returns {String}
     */
    buttonText() {
      return this.success
        ? this.$string('general.ometria.submitted')
        : this.$string('general.ometria.submit')
    },
  },

  mounted() {
    if (!window.ometria || !window.ometria?.ajaxFormSubmit) {
      return
    }

    window.ometria?.ajaxFormSubmit('#ometria_form', this.handleResponse)
  },

  methods: {

    /**
     * Handles form submit response.
     * @param {Object} response - Form submit response.
     */
    handleResponse(response) {
      if (!response.ok) {
        this.error = response.errors[0][1]

        return
      }

      this.success = true
      this.email = ''
    },
  },
}
</script>

<style lang="scss">
@import './newsletter-sign-up';
</style>
